export default "__VITE_ASSET__bffa4b8c__"